import { Box, type BoxProps } from '@chakra-ui/react'

export const InsuranceInfoBasic = ({ children, sx, ...rest }: BoxProps) => {
  return (
    <Box sx={{
      display: { base: 'grid', md: 'flex' },
      gridTemplateAreas: '"number date" "details details"',
      rowGap: 4,
      columnGap: { base: 4, md: 6, xl: 8 },
      ...sx,
    }} {...rest}>
      {children}
    </Box>
  )
}
